import { ExerciseSet } from "../pages/company/types";
import moment from "moment";

export const validatePhoneNumber = (number: string): boolean => {
  return /^\d{10,10}$/.test(number);
};

export const isValidEmail = (email: string): boolean => {
  const emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const extractTimeFromDateTime24 = (dateTimeString: string) => {
  const date = moment(dateTimeString, "YYYY-MM-DDTHH:mm:ss");
  return date.format("h:mm A"); // "h:mm A" format will give you "9:17 PM" for example
};

export const secondsToHMS = (seconds: number): string => {
  const duration = moment.duration(seconds, "seconds");
  const formattedDuration = moment
    .utc(duration.asMilliseconds())
    .format("HH:mm:ss");

  return formattedDuration;
};

export const extractTimeFromDateTime = (dateTimeString: string): string => {
  return moment(dateTimeString).format("HH:mm:ss");
};

export const millisToReadableFormat = (millis: number): string => {
  let seconds = millis / 1000;
  const minutes = Math.floor(seconds / 60);
  seconds = seconds % 60;
  let readableFormat = "";
  if (minutes > 0) {
    const readableSeconds = getReadableSeconds(seconds);
    if (minutes >= 10) {
      readableFormat = `${minutes}:${readableSeconds}`;
    } else {
      readableFormat = `0${minutes}:${readableSeconds}`;
    }
  } else {
    readableFormat = `00:${getReadableSeconds(seconds)}`;
  }
  return readableFormat;
};

const getReadableSeconds = (seconds: number): String => {
  if (seconds >= 10) {
    return seconds.toString();
  } else {
    return `0${seconds}`;
  }
};

export const getFormattedDate = () => {
  const date = new Date();
  const day = date.getDate();
  const month = date.getMonth() + 1;
  return `${day < 10 ? `0${day}` : day}-${
    month < 10 ? `0${month}` : month
  }-${date.getFullYear()}`;
};

export const getCurrentEpoch = () => {
  return new Date().getTime().toString();
};

export const getWodDuration = (wodExerciseSets: Array<ExerciseSet>) => {
  let duration = 0;
  wodExerciseSets.map((exerciseSet) => {
    duration += exerciseSet.duration;
  });
  return duration;
};

export const getReadableDate = (date: string) => {
  const newDate = new Date();
  newDate.setDate(Number(date.substring(0, 2)));
  newDate.setMonth(Number(date.substring(3, 5)) - 1);
  newDate.setFullYear(Number(date.substring(6, 10)));
  return `${moment(newDate).format("dddd, MMMM Do YYYY")}`;
};

export const getReadableDateString = (date: string) => {
  if (date) {
    const dateObj = moment(date);
    return dateObj.format("MMMM Do YYYY");
  }
};

export const getReadableShortDate = (date?: string) => {
  const newDate = new Date();
  if (date) {
    newDate.setDate(Number(date.substring(0, 2)));
    newDate.setMonth(Number(date.substring(3, 5)) - 1);
    newDate.setFullYear(Number(date.substring(6, 10)));
  }
  return `${moment(newDate).format("MMM Do yy")}`;
};

export const getReadableShortTime = (millis: number) => {
  const seconds = Math.floor(millis / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);

  const remainingMinutes = minutes % 60;
  const remainingSeconds = seconds % 60;

  let formattedTime = "";

  if (hours > 0) {
    formattedTime += `${hours}hr `;
  }

  if (remainingMinutes > 0) {
    formattedTime += `${remainingMinutes} mins`;
  }

  if (hours === 0 && remainingMinutes === 0) {
    formattedTime += `${remainingSeconds} secs`;
  }

  return formattedTime.trim();
};

export const capitalizeFirstLetter = (string: string) => {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  } else {
    return "N/A";
  }
};
export const findImageExtensions = (string: string): string | null => {
  const regex = /\.(jpg|jpeg|png)\b/i;
  const matches = string.match(regex);
  return matches ? matches[1] : null;
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
  }).format(amount);
};

export const getMemberType = (type: string) => {
  switch (type) {
    case "SUBSCRIBER":
      return "Subscriber";
    case "VISITOR":
      return "Visitor";
    case "GYM_MEMBER":
      return "Gym Member";
    case "ONLINE_MEMBER":
      return "Online Member";
    default:
      return "Unknown";
  }
};

export const getFreeBieRequestStatus = (type: string) => {
  switch (type) {
    case "TO_SEND":
      return "Awaiting to send";
    case "SENT":
      return "Sent";
    case "FAILED":
      return "Failed";
    default:
      return "N/A";
  }
};
export function calculateDiscountedPrice(
  price: number,
  discountPercentage: number
) {
  const discountAmount = (price * discountPercentage) / 100;
  const finalPrice = price - discountAmount;
  return finalPrice;
}

export const formatNumber = (num: number) => {
  if (!num) return;
  if (num >= 10000000) {
    // If number is 10 million or more
    let formattedNum = (num / 10000000).toFixed(1) + "M+";
    return formattedNum;
  } else if (num >= 100000) {
    // If number is 1 lakh or more
    let formattedNum = (num / 100000).toFixed(1) + "L+";
    return formattedNum;
  } else if (num >= 50) {
    // If number is 50 or more
    return num.toString(); // Convert number to string to maintain consistency
  } else {
    return num.toString(); // Convert number to string for consistency
  }
};
